<template>
    <div class="home">
        <img src="/images/logo.png" style="position: absolute; top: 10px; margin: 5px; z-index: 1000;" width="15%">
        <v-carousel :cycle="false">
            <v-carousel-item
                    v-for="(item,i) in itemSlider"
                    :key="item.id"
                    v-html="render_slider(item.image_file, item.link)"
                    reverse-transition="fade"
                    transition="fade"
            ></v-carousel-item>
        </v-carousel>
        <BasicNavigation></BasicNavigation>
    </div>
</template>

<script>
    import HomeAPI from "@/api/home";
    import BasicNavigation from "@/components/BasicNavigation";

    export default {
        layout: 'basic',
        components: {
            BasicNavigation
        },
        data() {
            return {
                itemSlider: []
            }
        },
        methods: {
            render_slider(url,link){
                if(link && link.includes("youtube.com")) {
                    return '<iframe width="100%" height="500px" src="'+ link +'?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                } else {
                    if(url.endsWith('mp4')) {
                        return '<video width="100%" height="500px" controls="controls" src='+url+'></video>';
                    } else {
                        return '<img width="100%" height="500px" src='+url+'>';
                    }
                }
            }
        },
        name: 'home',
        mounted: function(){
            HomeAPI.getSlider().then(response => {
                this.itemSlider = response.data.results.data;
            });
        }
    }
</script>
